<template>
  <div class="countent-wrapper">
    <bread-crumb></bread-crumb>
    <div class="view-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import breadCrumb from '@/common/breadcrumb/breadcrumb';
export default {
  name: 'countent',
  components: {
    breadCrumb
  },

}
</script>
<style lang="stylus" scoped>
.countent-wrapper {
  flex: 1;
  position: relative;

  .view-wrapper {
    position: absolute;
    top: 58px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/components/countent/countent.vue